import { render, staticRenderFns } from "./AvgTempCalc.vue?vue&type=template&id=2f6cd398"
import script from "./AvgTempCalc.vue?vue&type=script&lang=js"
export * from "./AvgTempCalc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports